var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGardenDashboardTotalGardensSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GardenDashboardTotalGardensSVG 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "square",
    d: "M6.87863 5.83881H93.1213C94.1725 5.83881 95.0246 6.69096 95.0246 7.74213V92.2578C95.0246 93.309 94.1725 94.1611 93.1213 94.1611H6.87863C5.82746 94.1611 4.97533 93.309 4.97533 92.2578V7.74213C4.97533 6.69096 5.82746 5.83881 6.87863 5.83881Z",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rightVert",
    d: "M65.2816 92.267V7.75123C65.2816 6.70006 65.2816 93.3182 65.2816 92.267Z",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bottomHorz",
    d: "M4.98426 66.3402H95.0242C96.0754 66.3402 3.93309 66.3402 4.98426 66.3402Z",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leftVert",
    d: "M36 93.991V7.00896C36 5.97374 36 95.0263 36 93.991Z",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "topHorz",
    d: "M4.98426 35.0373H95.0242C96.0754 35.0373 3.93309 35.0373 4.98426 35.0373Z",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardenDashboardTotalGardensSvg);
export default __webpack_public_path__ + "static/media/GardenDashboardTotalGardensSVG.afa58c1eeb2ec240ac60582e0ac3f8ca.svg";
export { ForwardRef as ReactComponent };